import styled from 'styled-components';
import {
  Wrapper as commonWrapper,
  Holder as commonHolder,
  Panel as commonPanel,
  Close as commonClose,
  CloseIcon as commonCloseIcon,
  Content as commonContent
} from 'assets/Common/Modal';

export const Wrapper = styled.div`
  ${commonWrapper}
`;

export const Holder = styled.div`
  ${commonHolder}
`;

export const Panel = styled.div`
  ${commonPanel}
`;

export const Close = styled.a`
  ${commonClose}
`;

export const CloseIcon = styled.i`
  ${commonCloseIcon}
`;

export const Content = styled.div`
  ${commonContent}
`;
